var map = {
	"./failure/ru_failure_1.png": "f268",
	"./failure/ru_failure_2.png": "ddec",
	"./failure/ru_failure_3.png": "956e",
	"./failure/ru_failure_4.png": "db31",
	"./failure/ru_failure_5.png": "3340",
	"./failure/ru_failure_6.png": "ae34",
	"./failure/ru_failure_7.png": "c08f",
	"./failure/ru_failure_8.png": "ca62",
	"./success/ru_success_1.png": "9ffd",
	"./success/ru_success_2.png": "0d6b",
	"./success/ru_success_3.png": "c876",
	"./success/ru_success_4.png": "d043",
	"./success/ru_success_5.png": "cd31",
	"./success/ru_success_6.png": "3d53",
	"./success/ru_success_7.png": "d150"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dbb5";